<script src="../store/module/auth.js"></script>
<style
  scoped
  lang="less">

  .title {
    line-height: 50px;
    font-size: 16px;
    color: #333;
  }

  .row-body {
    font-family: songti;
    border: 1px solid #c9c9c9;
  }

  #company-list {
    max-height: 270px;
    overflow-y: scroll;
  }

  .company-row {
    display: flex;
    justify-content:space-between;
    margin-bottom: 16px;
    height: 46px;
    line-height: 46px;
    border: 1px solid #eee;
    .comdetail_l{
      display: flex;
      flex:1;
    }
    span{
      display: inline-block;
    }
    &.selected {
      background: #f2f8fd;
      /*border: 2px solid #0077db;*/
      .company-name {
        border: 2px solid #0077db;
        background: url("../assets/duihao_check.png") no-repeat right bottom;
      }
       .edit-btn, .delete-btn, .more, .default{
        color: #0077db;
      }
    }
    .company-name {
      display: flex;
      margin: 5px 0 5px 40px;
      font-size: 14px;
      width: 200px;
      color: #666;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      border: 2px solid #ddd;
      align-items: center;
      justify-content:center;
    }
  }

  .company-rep {
    display: inline-block;
    margin-left: 14px;
    font-size: 14px;
    width: 126px;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #666;
  }

  .company-addr {
    display: inline-block;
    margin-left: 14px;
    font-size: 14px;
    flex:1;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #666;
  }
  .more {
    display: inline-block;
    margin-left: 80px;
    font-size: 14px;
    width: 70px;
    color: #666;
    cursor: pointer;
  }

  .default {
    display: inline-block;
    margin-left: 14px;
    font-size: 14px;
    width: 70px;
    color: #666;
  }
  .insured {
    margin-right: 14px;
    display: inline-block;
    height: 12px;
    font-size: 12px;
    color: #0077db;
    span {
      display: inline;
      border-radius: 5px;
      padding: 2px;
      border: 1px solid #0077db;
    }
  }

  .add-btn {
    float: right;
    color: #495f6a;
    border: 1px solid #ccc;
    padding: 0 10px;
    cursor: pointer;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    margin-top: 4px;
    i {
      margin-right: 5px;
    }
  }

  .edit-btn {
    color: #999;
    cursor: pointer;
    font-size: 14px;
    i {
      margin-right: 10px;
    }
  }

  .delete-btn {
    margin-left: 20px;
    color: #999;
    font-size: 14px;
    cursor: pointer;
    i {
      margin-right: 10px;
    }
  }

  #payment-detail {
    margin-bottom: 24px;
  }

  .empty-company {
    border: 1px solid #aaa;
  }

  /*.company-form {*/
    /*margin-top: 20px;*/
    /*margin-bottom: 20px;*/
    /*width: 400px;*/
  /*}*/

  .save-btn {
    width: 100px;
    height: 30px;
    background: #0077db;
    border-radius: 2px;
    border: none;
    padding: 0.7em;
    font-size: 14px;
    margin-left: 100px;
  }
</style>
<template>
  <div id="payment-detail">
    <span class="title">公司列表</span>
    <!--<span class="add-btn" @click="addCompany"><i class="el-icon-plus"></i>新增公司</span>-->
    <span class="add-btn" @click="addCompany"><i class="el-icon-plus"></i>新增公司</span>

    <div id="company-list">
      <div v-if="isEmptyCompanies"  class="company-row" >
        <p style="text-align: center;flex: 1 0 100%;">暂无公司信息，请先新增公司</p>
      </div>
      <div v-if="!isEmptyCompanies" class="company-row"
           v-for="(company, index) in $store.state.auth.companies"
           @click="select(index)"
           :class="{selected: selectedIndex === index}">
        <div class="comdetail_l">
          <span class="company-name">{{ company.name }}</span>
          <span class="company-rep">{{ company.legalPerson }}</span>
          <span class="company-addr">{{ company.address }}</span>
          <span class="insured"><span v-if="company.isInsured">参保人信息</span></span>
          <span class="default"><span v-if="company.isDefault">默认</span></span>
        </div>
        <!--<span class="more" @click="more(index)">查看更多</span>-->

        <div class="r" style="padding-right:20px;">
          <span v-if="!company.isInsured" class="edit-btn" v-on:click="edit(index)"><i class="el-icon-edit"></i>修改</span>
          <span class="delete-btn" v-on:click="deleteCompany(index)"><i class="el-icon-delete"></i>删除</span>
        </div>

      </div>
      <!--<div v-if="$store.state.auth.companies.length <= 0" style="padding-bottom: 67px"></div>-->
    </div>
    <!--<company-dialog @submit="fetchData" ref="companyDialog"></company-dialog>-->
  </div>
</template>
<script>
  import companyApi from '../api/company'
  export default {
    data () {
      return {
        companies: [],
        selectedIndex: -1,
        isEmptyCompanies: false,
        inSave: false,
        company: {
          name: '',
          legalPerson: '',
          address: '',
          isDefault: false
        },
        isShowForm: false
      }
    },
    created () {
      const customer = window.localStorage.getItem('customer')
      if (customer) {
        const cus  = JSON.parse(customer)
        this.$store.state.auth.companies = [cus]
        this.select(0)
      } else {
        this.fetchData()
      }
    },
    methods: {
      fetchData () {
        let vm = this
        let companies = !vm.$store.state.auth.companies
        let companiess = window.localStorage.getItem('companies')
        window.localStorage.setItem('companies', JSON.stringify([]))
        vm.$store.state.auth.companies = []
        if (!companies || !companiess) {
          let jsonStr = window.localStorage.getItem('companies')
          vm.$store.state.auth.companies = JSON.parse(jsonStr)

          companyApi.fetchAllCompanies(bd => {
            window.localStorage.setItem('companies', JSON.stringify(bd))
            vm.companies = bd
            vm.$store.state.auth.companies = bd
            vm.isEmptyCompanies = vm.$store.state.auth.companies.length === 0;
            if (!vm.isEmptyCompanies) {
              let index = vm.companies.findIndex(c => { return c.isDefault })
              index = index >= 0 ? index : 0
              vm.select(index)
            }
          })
        }
        if (vm.$store.state.auth.companies.length <= 0) {
          let jsonStr = window.localStorage.getItem('companies')
          vm.$store.state.auth.companies = JSON.parse(jsonStr)
        }
        vm.isEmptyCompanies = vm.$store.state.auth.companies.length === 0;
      },
      addCompany () {
//        this.$refs.companyDialog.title = '新增公司'
//        this.$refs.companyDialog.openDialog()
        this.$router.push('/company')
      },
      select (index) {
        this.selectedIndex = index
        this.$store.state.global.currentCompany = this.$store.state.auth.companies[index]
        this.$emit('updateCompany', this.$store.state.auth.companies[index].id)
        // todo 缓存优化
        window.localStorage.removeItem('companies')
        window.localStorage.removeItem('customer')
      },
      edit (index) {
//        this.$refs.companyDialog.title = '修改公司'
//        this.$refs.companyDialog.openDialog(this.$store.state.auth.companies[index])
        let companyId = this.companies[index].id
        this.$router.push({path: '/company', query: {company: window.btoa(companyId)}})
      },
      more(index) {
        let companyId = this.companies[index].id
        this.$router.push({path: '/company', query: {company: window.btoa(companyId), mode: 'readonly'}})
      },
      deleteCompany (index) {
        let vm = this
        this.$confirm('确认删除该公司吗？', '删除公司', {
          type: 'warning'
        }).then(() => {
          let company = this.$store.state.auth.companies[index]
          companyApi.deleteCompany(company.id,
            bd => {
              vm.$store.state.auth.companies.splice(index, 1)
              let companies = JSON.parse(window.localStorage.getItem('companies'))
              if (companies) {
                companies.splice(index, 1)
                window.localStorage.setItem('companies', JSON.stringify(companies))
              }
              vm.$message({
                type: 'success',
                message: '删除成功！'
              })
            },
            bd => {
              vm.$message.error('删除失败!' + bd.message)
            }
          )
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CompanySelection.vue?14a30c82